// Thin fetch wrapper. All API calls go through here so the cookie + content
// type are consistent and error handling is centralized.

const BASE = '/api';

export class ApiError extends Error {
  constructor(public readonly status: number, message: string, public readonly body?: unknown) {
    super(message);
  }
}

async function send(method: string, path: string, body?: unknown): Promise<Response> {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    ...(body !== undefined
      ? { headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) }
      : {})
  });
  return res;
}

async function expectJson<T>(res: Response): Promise<T> {
  if (res.status === 204) return undefined as unknown as T;
  const text = await res.text();
  const parsed = text ? (JSON.parse(text) as unknown) : null;
  if (!res.ok) {
    const message = typeof parsed === 'object' && parsed && 'message' in parsed ? String((parsed as { message: unknown }).message) : res.statusText;
    throw new ApiError(res.status, message, parsed);
  }
  return parsed as T;
}

export const api = {
  async get<T>(path: string): Promise<T> {
    return expectJson<T>(await send('GET', path));
  },
  async post<T>(path: string, body?: unknown): Promise<T> {
    return expectJson<T>(await send('POST', path, body));
  }
};
